<template>
  <div>
    <div
      :class="$style.dropShopOpeningHours"
    >
      <template
        v-for="(entry, index) in getOpeningSummary(dropShop)"
      >
        <div
          v-if="entry.translatedDay !== $t('parcelshop.Annual_Closing')"
          :key="index"
        >
          {{ entry.translatedDay }}
        </div>
        <div
          v-if="entry.translatedDay !== $t('parcelshop.Annual_Closing')"
          :key="index"
        >
          <div>
            <span
              v-for="(hours, indexHours) in entry.hours"
              :key="indexHours">{{ displayHours(hours, indexHours, entry.hours.length) }}
            </span>
          </div>
        </div>
      </template>
    </div>
    <div :class="$style.annualClose" >
      <template
        v-for="(entry, index) in getOpeningSummary(dropShop)"
      >
        <div
          v-if="entry.translatedDay == $t('parcelshop.Annual_Closing')"
          :key="index"
        >
          {{ entry.translatedDay }}
        </div>
        <div
          v-if="entry.translatedDay == $t('parcelshop.Annual_Closing')"
          :key="index"
        >
          <div
            v-for="(hours, indexHours) in entry.hours"
            :key="indexHours">{{ hours }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import i18next from 'i18next'
export default {
  props: {
    dropShop: {
      type: Object,
      required: true
    }
  },
  methods: {
    getOpeningSummary(dropShop) {
      return dropShop.openingHoursSummary
        .replace(/\|([^#])/g, '|----| $1')
        .split('|----|')
        .map(entry => {
          const [day, hoursStr] = entry.replace(":#",": #").split(': ', 2)
          const dayString = day.replace(/[^A-Z]+/gi, '')
          const regexp = /\|\s?/g
          let hoursArray = hoursStr.replace(regexp, '').substring(1,hoursStr.length)
          const hours = hoursArray.split(/\|?#/)

          let translatedDay
          if (dayString.length == 4) {
            translatedDay =
              i18next.t('parcelshop.' + dayString.substring(0,2)) +
              ' - ' +
              i18next.t('parcelshop.' + dayString.slice(-2))
          } else if (dayString.length == 2) {
            translatedDay = i18next.t('parcelshop.' + dayString)
          } else if(dayString.includes("Annual")) {
            translatedDay = i18next.t('parcelshop.Annual_Closing')
          } else{
            translatedDay=dayString
          }
          return { translatedDay, hours }
        })
    },
    displayHours(hoursToDisplay, index, length){
      if(index != (length-1)) {
        hoursToDisplay= hoursToDisplay + ',';
      }
      
      return hoursToDisplay ;
    }
  }
}
</script>

<style module>
.dropShopOpeningHours {
  display: grid;
  grid-column-gap: 1em;
  grid-template-columns: max-content auto;
}

.annualClose {
  display: grid;
  grid-column-gap: 1em;
  grid-template-columns: max-content auto;
  margin-top: 0.5em;
}

</style>



// WEBPACK FOOTER //
// client/components/drop-shop/CbrDropShopOpeningHours.vue